// Copyright 2024 praveen.konathala
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import dayjs from 'dayjs';

export const getDateRange = (
  option: string,
): { startDate: string; endDate: string } => {
  let startDate = dayjs();
  let endDate = dayjs().endOf('day');

  switch (option.toLowerCase()) {
    case 'today':
      startDate = dayjs().startOf('day');
      break;
    case 'yesterday':
      startDate = dayjs().subtract(1, 'day').startOf('day');
      endDate = dayjs().subtract(1, 'day').endOf('day');
      break;
    case 'this week':
      startDate = dayjs().startOf('week');
      break;
    case 'last week':
      startDate = dayjs().subtract(1, 'week').startOf('week');
      endDate = dayjs().subtract(1, 'week').endOf('week');
      break;
    case 'this month':
      startDate = dayjs().startOf('month');
      break;
    case 'last month':
      startDate = dayjs().subtract(1, 'month').startOf('month');
      endDate = dayjs().subtract(1, 'month').endOf('month');
      break;
    case 'this year':
      startDate = dayjs().startOf('year');
      break;
    case 'last year':
      startDate = dayjs().subtract(1, 'year').startOf('year');
      endDate = dayjs().subtract(1, 'year').endOf('year');
      break;
    case 'last 7 days':
      startDate = dayjs().subtract(7, 'day').startOf('day');
      break;
    case 'last 30 days':
      startDate = dayjs().subtract(30, 'day').startOf('day');
      break;
    default:
      break;
  }

  return {
    startDate: startDate.format('YYYY-MM-DD'),
    endDate: endDate.format('YYYY-MM-DD'),
  };
};
export const formatEndDate = (date: Date) => {
  return dayjs(date).endOf('day').format('YYYY-MM-DDTHH:mm:ss');
};

export const convertToISODate = (dateString: string): string => {
  const [month, day, year] = dateString.split('/');
  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};
